import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {staticPagesList_template} from "../components/templates/staticPagesList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class static_page extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected staticPagesList: staticPagesList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.staticPagesList = new staticPagesList_template("staticPagesList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Static pages List");
        return [this.staticPagesList.build()];
    }

    protected getModuleName(): string {
        return "static_page";
    }

    fillPage() {
        this.getStaticPageData();
    }

    protected getStaticPageData() {
        this.loadingIn(this.staticPagesList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.staticPagesList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/staticpage/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetStaticPageDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetStaticPageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let static_pages = responseParsed.data;
                let permissions = responseParsed.extraData.permissions;


                obj.viewModel.staticPagesList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.staticPagesList.setResultInfo(totalCount, totalPage, execTime)

                obj.staticPagesList.setStaticPages(static_pages, obj.getBrandId());
                obj.staticPagesList.setPermissions(permissions)

            });
            obj.loadingOut(obj.staticPagesList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected staticPagesListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getStaticPageData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getStaticPageData();
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    protected viewStaticPage(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/static-pages/view/' + id + '/')
    }

    protected addStaticPage() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/static-pages/add/')
    }

    protected deleteStaticPage(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/staticpage/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.staticPagesList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Static page" + "<strong>" + responseParsed.data.name + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getStaticPageData()
                })

                obj.loadingOut(obj.staticPagesList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }


}


// WEBPACK FOOTER //
// ./js/modules/static_page.ts